import { Action } from 'redux';

import { UpdateAssetListItems } from '../../app/actions/AppActionTypes';
import { isActionFactory } from '../../app/actions/isActionFactory';
import { AssetListItem } from '../../ts/ServerApi/types/AssetListItem';

export interface UpdateAssetListItemsAction extends Action {
  items: AssetListItem[];
}

export function updateAssetListItems(items: AssetListItem[]) {
  return {
    type: UpdateAssetListItems,
    items,
  };
}

export const isUpdateAssetListItemsAction = isActionFactory<UpdateAssetListItemsAction>(UpdateAssetListItems);
